module.exports = __webpack_public_path__ + "static/media/teleicon-outline.5dc5e36d.woff";